import { FC, PropsWithChildren } from "react";
import {
  Configure,
  connectMenu,
  connectRange,
  connectRefinementList,
  InstantSearch,
} from "react-instantsearch-dom";
import { SearchClient } from "algoliasearch/dist/algoliasearch-lite";
import { SearchState } from "react-instantsearch-core";
import { ConfigureProps } from "src/types/Algolia";
import { CATEGORIES_FACET } from "src/utils/algolia";

export const VirtualRefinementList = connectRefinementList(() => null);
export const VirtualMenu = connectMenu(() => null);
export const VirtualPriceRange = connectRange(() => null);

interface Props {
  searchClient: SearchClient | null;
  searchState?: SearchState;
  onSearchStateChange?: (state: SearchState) => void;
  indexName: string;
  configureProps: ConfigureProps;
}

export const VirtualInstantSearch: FC<PropsWithChildren<Props>> = ({
  searchClient,
  searchState,
  indexName,
  onSearchStateChange,
  configureProps,
  children,
}) => (
  <InstantSearch
    searchClient={searchClient}
    indexName={indexName}
    searchState={searchState}
    onSearchStateChange={onSearchStateChange}
  >
    <Configure
      {...configureProps}
      page={
        searchState?.page && searchState?.page !== 1 ? searchState?.page : 0
      }
    />
    {children}

    <VirtualRefinementList attribute={CATEGORIES_FACET} limit={1000} />
  </InstantSearch>
);
